import { IconGitHub } from "@/assets/icons/geist/IconGitHub";
import { IconGitLab } from "@/assets/icons/geist/IconGitLab";
import { IconGit } from "@/assets/icons/geist/IconGit";
import { WebhookProvider, WebhookType } from "gitpod-next-api/gitpod/v1/webhook_pb";
import type { FC } from "react";
import type { BaseIconProps } from "@/assets/icons/utils";

/**
 * Display configuration for webhook SCM providers.
 * Maps WebhookProvider enum values to their corresponding icon component and display name.
 */
export const WEBHOOK_PROVIDER_CONFIG: Record<WebhookProvider, { icon: FC<BaseIconProps>; name: string }> = {
    [WebhookProvider.GITHUB]: { icon: IconGitHub, name: "GitHub" },
    [WebhookProvider.GITLAB]: { icon: IconGitLab, name: "GitLab" },
    [WebhookProvider.UNSPECIFIED]: { icon: IconGit, name: "Unknown" },
};

/**
 * Display configuration for webhook scope types.
 * Maps WebhookType enum values to their display name.
 */
export const WEBHOOK_TYPE_CONFIG: Record<WebhookType, { name: string }> = {
    [WebhookType.SCM_REPOSITORY]: { name: "Repository" },
    [WebhookType.SCM_ORGANIZATION]: { name: "Organization" },
    [WebhookType.UNSPECIFIED]: { name: "Unknown" },
};
